import {initAdvancedFeaturesIndications} from "../advancedFeatures/data/advancedFeatures.service";
import React from "react";
import {Footer} from "./components/Footer";
import {InitOptions} from "../common/models/common.models";
import {BrowserRouter} from "react-router-dom";
import {createRoot} from "react-dom/client";

interface FooterInitOptions extends InitOptions {
    footer?: any;
}

function init(options: FooterInitOptions) {
    const footer: HTMLCollectionOf<Element> = document.getElementsByClassName('ti-footer');
    if (footer && footer.length) {
        const element = footer[0] as HTMLElement;
        const isInitialized = element.getAttribute('isInitialized') === 'true';
        const footerProps = {
            ...element.dataset,
            ...options.footer,
            isNewBrand: true,
            cookieDomain: options.domain,
            baseUrl: options.baseUrl,
        };
        if (!isInitialized) {
            element.setAttribute('isInitialized', 'true');
            const root = createRoot(element!);
            root.render(<BrowserRouter><Footer {...footerProps} /></BrowserRouter>);
        }
    }

    if (options.advancedFeatures && options.advancedFeatures.renderIndications) {
        initAdvancedFeaturesIndications(options.baseUrl, false);
    }
}

export default {
    init
};
